<template>
  <el-dialog
    class="rc-dialog"
    title="中网院访问设置"
    :visible.sync="dialogInfo.flag"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="500px"
  >
    <el-form
      size="small"
      ref="zwySettingForm"
      label-position="right"
      label-width="150px"
      :model="form"
    >
      <el-form-item
        label="能否访问中网院："
        prop="canVisitZwy"
        :rules="[
          {
            required: true,
            message: '请选择能否访问中网院',
            trigger: 'change',
          },
        ]"
      >
        <el-radio-group v-model="form.canVisitZwy">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="confirm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { updateCanVisitZwy } from "@/api/user.js";
import { BaseConfirm } from "@/components/Confirm";
export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          flag: false,
          isBatch: false,
          selectList: [],
        };
      },
    },
  },
  data() {
    return {
      form: {
        canVisitZwy: null,
      },
    };
  },
  created() {
    if (!this.dialogInfo.isBatch) {
      this.form.canVisitZwy = this.dialogInfo.defaultStatus;
    }
  },
  methods: {
    confirm() {
      this.$refs.zwySettingForm.validate(async (valid) => {
        if (valid) {
          if (this.dialogInfo.isBatch) {
            const flag = await BaseConfirm(
              `确认批量设置选中用户的中网院访问为${
                this.form.canVisitZwy == 1 ? "是" : "否"
              }吗？`
            );
            if (!flag) return;
          }
          updateCanVisitZwy({
            canVisitZwy: this.form.canVisitZwy,
            userIds: this.dialogInfo.uuids,
          }).then((res) => {
            this.$message.success("操作成功");
            this.$emit("close", true);
          });
        }
      });
    },
    closeDialog() {
      this.$emit("close");
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped></style>
